import React, { useEffect, useState, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { HeroSection } from './components/HeroSection';
import { ValueProposition } from './components/ClosingSection';
import { PortfolioSection } from './components/PortfolioSection';
import { DesignSection } from './components/DesignSection';
import { ProcessSection } from './components/ProcessSection';
import { TeamSection } from './components/TeamSection';
import { InstitutionalTrust } from './components/InstitutionalTrust';
import { FooterCTA } from './components/FooterCTA';
export function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const whatsappUrl = 'https://wa.me/573182434499?text=Hola%20Gerfaj%2C%20vi%20su%20p%C3%A1gina%20de%20Reformas%20y%20quiero%20una%20asesor%C3%ADa%20para%20mi%20proyecto.';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    // Inject preconnect links
    const preconnects = [{
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    }, {
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossOrigin: 'anonymous'
    }, {
      rel: 'preconnect',
      href: 'https://images.unsplash.com'
    }, {
      rel: 'dns-prefetch',
      href: 'https://wa.me'
    }];
    preconnects.forEach(({
      rel,
      href,
      crossOrigin
    }) => {
      if (!document.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = rel;
        link.href = href;
        if (crossOrigin) link.crossOrigin = crossOrigin;
        document.head.appendChild(link);
      }
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-gerfaj-dark text-white font-inter selection:bg-gerfaj-orange selection:text-white relative" data-id="element-0">
      {/* Sticky Header */}
      <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-gerfaj-dark/90 backdrop-blur-md border-b border-white/10 py-3 shadow-lg' : 'bg-transparent py-5'}`} data-id="element-1">
        <div className="container mx-auto px-6 max-w-6xl flex items-center justify-between" data-id="element-2">
          <div className="flex items-center" data-id="element-3">
            <img src="https://cdn.magicpatterns.com/uploads/8J5rvBbaJ8KDy4mkSYfR5w/Logo-Gerfaj.png" alt="Gerfaj - Arquitectura e Ingeniería" className="h-10 sm:h-12 w-auto brightness-0 invert" loading="eager" decoding="async" width={200} height={48} data-id="element-4" />
          </div>

          <AnimatePresence data-id="element-5">
            {isScrolled && <motion.a initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-gerfaj-orange hover:bg-orange-600 text-white font-bold text-sm px-4 py-2 rounded-lg transition-colors duration-300" data-id="element-6">
                <MessageCircle className="w-4 h-4" data-id="element-7" />
                <span className="hidden sm:inline" data-id="element-8">Asesoría</span>
              </motion.a>}
          </AnimatePresence>
        </div>
      </motion.header>

      <main data-id="element-9">
        <HeroSection data-id="element-10" />
        <ValueProposition data-id="element-11" />
        <PortfolioSection data-id="element-12" />
        <DesignSection data-id="element-13" />
        <ProcessSection data-id="element-14" />
        <TeamSection data-id="element-15" />
        <InstitutionalTrust data-id="element-16" />
        <FooterCTA data-id="element-17" />
      </main>

      {/* Floating WhatsApp Button */}
      <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-20 sm:bottom-6 right-4 sm:right-6 z-50 bg-gerfaj-orange hover:bg-orange-600 text-white p-4 rounded-full shadow-[0_0_20px_rgba(255,102,0,0.6)] transition-transform hover:scale-110 duration-300 cta-glow flex items-center justify-center" aria-label="Contactar por WhatsApp" data-id="element-18">
        <MessageCircle className="w-8 h-8" data-id="element-19" />
      </a>
    </div>;
}